<template>
  <div>
    <Breadcrumb :title="'Correction'"></Breadcrumb>
    <IssuanceForm
      :ref="'IssuanceInfoForm'"
      :ProgramUnitClassJsonData="ProgramUnitClassJsonData"
      :partnerAutoCompleteDisplayedValue="partnerAutoCompleteDisplayedValue"
      :programAutoCompleteDisplayedValue="programAutoCompleteDisplayedValue"
      :IssuanceInfo="IssuanceJSON"
      :IssuanceModalLabel="IssuanceCorrectionModalConfig"
      :editPendingCorrection="true"
    ></IssuanceForm>
    <TransferForm :ref="'TransferInfoForm'" 
    :ProgramUnitClassJsonData="ProgramUnitClassJsonData" 
	  :TransferInfo="TransferJSON" 
    :TransferModalLabel="TransferCorrectionModalConfig" 
    :editPendingCorrection="true">
    </TransferForm>
    <VestingForm
      :ref="'VestingInfoForm'"
      :ProgramUnitClassJsonData="ProgramUnitClassJsonData"
      :VestingInfo="VestingJSON"
      :VestingModalLabel="VestingCorrectionModalConfig"
      :editPendingCorrection="true"
    ></VestingForm>
    <div class="form-row">
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
      <div class="form-group col-md-7" >
        <!-- <label for="kendo-select" style="float:right;" >Correction Type</label> -->
              <div  class="form-group" style="float:right; width:50%" id="kendo-select">
               <kendo-dropdownlist 
                        id="ddlBusinessEvent"
                        v-model="selectedBusinessEvent"
                        :data-source="BusinessEventOptions"
                        :data-text-field="'Option'"
                        @change="onBusinessEventChange"
                        :data-value-field="'Option'">
              </kendo-dropdownlist>
              </div>
      </div>
      
    </div>
    <div class="btnDiv">
      <BaseToolBar :config="toolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :config="gridConfig"
        :excelExport="excelExport"
        :query="gridConfig.query"
        :mode="'editform'"
				:colorizeColumn=true
        @EditItem="EditCorrection"
        @AttachItem="CorrectionAttachment"
      ></BaseGrid>
    </div>
    <CorrectionDocumentDropoffForm
      ref="correctionDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedCorrection"
    ></CorrectionDocumentDropoffForm>
  </div>
</template>

<script>
/* eslint-disable vue/consistent-return */
import $ from "jquery";
import {
  //CorrectionEventGridConfig,
  CorrectionEventToolbarConfig,
  CorrectionApproveConfig,
  IssuanceCorrectionConfig,
  TransferCorrectionConfig,
  VestingCorrectionConfig
} from "./CorrectionEventConfig.js";
import BaseModelCorrection from "@/models/BaseModelCorrection.js";

import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
//import CorrectionForm from "@/components/forms/CorrectionForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelDocument from "@/models/BaseModelDocument.js";
//import BaseModelCorrectionLog from "@/models/BaseModelCorrectionLog.js";
import IssuanceForm from "@/components/forms/IssuanceForm.vue";
import TransferForm from "@/components/forms/TransferForm.vue";
import VestingForm from "@/components/forms/VestingForm.vue";
import { mapGetters, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import { isNullOrUndefined } from 'util';

import CorrectionDocumentDropoffForm from "@/components/forms/CorrectionDocumentDropoffForm.vue";

export default {
  name: "CorrectionEvent",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  computed:{
    ...mapGetters("getModule",["withFilter"]),
    ...mapState("postModule",["response"]),
    gridConfig(){
      switch (this.selectedBusinessEvent) {
        case "Issuance":
          return IssuanceCorrectionConfig
          break;
        case "Transfer":
          return TransferCorrectionConfig
          break;
        case "Vesting":
          return VestingCorrectionConfig
          break; 
        default:
          break;
      }
    }
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    IssuanceForm,
    TransferForm,
    VestingForm,
    CorrectionDocumentDropoffForm
  },
  data: function() {
    return {
      //gridConfig: CorrectionEventGridConfig,
      search: {
        SearchData: ""
      },
      CorrectionGridId: "CorrectionGrid",
      CorrectionMasterData: {},
      toolbarConfig: CorrectionEventToolbarConfig,
      BaseModelCorrection: BaseModelCorrection,
      BaseModelUnitClass: BaseModelUnitClass,
      //BaseModelCorrectionLog:BaseModelCorrectionLog,
      // Document dropoff modal
      docModalConfig: {
        modalName: "Correction Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      CorrectionJSON: [],
      CorrectionEditJSON: {
        Id: null,
        BusinessEvent: "",
        ProgramId: null,
        ProgramTitle: "",
        SenderId:null,
        SenderFullName: "",
        ReceiverId:null,
        ReceiverFullName:"",
        UnitClass: "",
        UnitType: "",
        UnitPool: "",
        Unit: null,
        VestStartDate: null,
        Year:null,
        VestedDate:null,
        Percentage:null,
        VestedUnit:null,
        SpecialArrangement:"",
        TransactionDate: null,
        BatchGUID:""
      },
      selectedCorrection:{},
      BusinessEventOptions:[{"Option":"Issuance"},{"Option":"Transfer"},{"Option":"Vesting"}],
      selectedBusinessEvent:"Issuance",
      IssuanceJSON: [],
      partnerAutoCompleteDisplayedValue: {
        displayedValue: ""
      },
      programAutoCompleteDisplayedValue: {
        displayedValue: ""
      },
      ProgramUnitClassJsonData: {
        option: []
      },
      TransferJSON: {},
      VestingJSON:{},
      IssuanceCorrectionModalConfig:{
        modalName: "Edit Issuance Correction",
        modalAddorEdit: "edit",
        modalIdandRef: "IssuanceCorrectionForm",
      },
      TransferCorrectionModalConfig:{
        modalName: "Edit Transfer Correction",
        modalAddorEdit: "edit",
        modalIdandRef: "TransferCorrectionForm",
      },
      VestingCorrectionModalConfig:{
        modalName: "Edit Vesting Correction",
        modalAddorEdit: "edit",
        modalIdandRef: "VestingCorrectionForm",
      } 
    };
  },
  methods: {
    ...mapActions("postModule",['DeleteItem','UpdateAllItems','CreateAllItems']),

    UpdateCorrectionMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.CorrectionMasterData = filterMasterData;
      } else {
        this.CorrectionMasterData = JSON.parse(
          JSON.stringify(
            $("#CorrectionGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
      //Disable Rows which are not pending
      this._disableGridRow("CorrectionGrid","Status","neq","pending")
    },
    toolbarOnClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnApproveCorrection":
          this.ApproveCorrection();
          break;
        case "btnBulkAttachment":
          this.AttachBatchDocuments();
          break;
        // case "btnRefresh":
        // 	this.refreshGrid();
        // 	break;
      }
      this._baseToolBarEvents("CorrectionGrid", ...arguments);
    },

    ApproveCorrection() {
      let grid = $("#CorrectionGrid").data("kendoGrid");
      let selectedItem = [];
      grid.select().each(function() {
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        if (selectedDataItem.Status == "Pending") {
          selectedDataItem.Status = "Processing";
          //push the dataItem into the array
          selectedItem.push(selectedDataItem);
        }
      });
      if (selectedItem.length <= 0) {
        this._AlertPopup("Please select atleast one pending item.", "info");
      } else {
        const message =
          "Are you sure you want to approve the selected record(s)?";
          this._ConfirmationPopup(message, "APPROVE").then(result => {
          if (result.value) {
            //let loader = this.$loading.show();
 this._APICrudPopup("APICrudpopup");
let updateobject = {
              Correction: { config: CorrectionApproveConfig, updateData: selectedItem }
            };
            this.UpdateAllItems(updateobject).then(response => {
              //refresh the grid data only after the update gets completed
                $("#CorrectionGrid").data().kendoGrid.dataSource.read();
              this._AlertPopup("Submitted for Processing Successfully!", "success");
            }).catch(error=>{
              this._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
              //loader.hide();
            })
          }
        });
      }
    },

    filterGrid: function() {
      let self = this;

      let currentMasterdata = this.CorrectionMasterData;

      let filteredData = this._filterGrid(
        this.CorrectionMasterData,
        this.search.SearchData
      );
      $("#CorrectionGrid").data("kendoGrid").dataSource.data(filteredData);
      this.UpdateCorrectionMasterData(true, currentMasterdata);
    },
    EditCorrection(e){
      switch (this.selectedBusinessEvent) {
        case "Issuance":
          this.OpenIssuanceEditForm(e);
          break;
        case "Transfer":
          this.OpenTransferEditForm(e);
          break;
        case "Vesting":
          this.OpenVestingEditForm(e);
          break;  
        default:
          break;
      }

    },
    OpenIssuanceEditForm(e){
      //alert("Edit button clicked from BaseGrid..");
      var gview = window.$("#CorrectionGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      //  alert(JSON.stringify(dataItem));      
      this.IssuanceEditJSON = dataItem;
      // this.IssuanceJSON = this.IssuanceEditJSON;
      this.partnerAutoCompleteDisplayedValue.displayedValue = this.IssuanceEditJSON.ReceiverFullName;
      this.programAutoCompleteDisplayedValue.displayedValue = this.IssuanceEditJSON.ProgramTitle;
      this.ProgramUnitClassJsonData.option = [];

      let unitClassQuery = { filter: "Program/Id eq " + dataItem.ProgramId }

      this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, unitClassQuery)
      this.IssuanceJSON = this.IssuanceEditJSON;    
      //Calculating Outstanding Treasury Units  
      this.$refs.IssuanceInfoForm.OutstandingTreasuryUnits = 0;
      this.$refs.IssuanceInfoForm.calculateOutstandingTreasuryUnits(this.IssuanceJSON); 
       window.$("#IssuanceCorrectionForm").modal("toggle");
    },
    OpenTransferEditForm(e){
      let self = this;

        let gview = window.$("#CorrectionGrid").data("kendoGrid");
        let dataItem = JSON.parse(
          JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
        );
        this.TransferEditJSON = dataItem ;
        let unitClassQuery = { filter: "ProgramId eq " + dataItem.ProgramId }
        this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, unitClassQuery)

        this.TransferJSON = this.TransferEditJSON;

        //this.$refs.TransferInfoForm.AvailableUnits = 0;
        this.$refs.TransferInfoForm.calculateAvailableUnits(this.TransferJSON);
        window.$("#TransferCorrectionForm").modal("toggle");
    },
    OpenVestingEditForm(e){

      let gview = window.$("#CorrectionGrid").data("kendoGrid");
      let dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      this.VestingEditJSON = dataItem;
      this.VestingEditJSON.Percentage = Number(dataItem.Percentage);

      this.ProgramUnitClassJsonData.option = [];
      this.ProgramUnitClassJsonData.option=this.withFilter(BaseModelUnitClass.list, {
        filter: "ProgramId eq " + dataItem.ProgramId
      })
      this.VestingJSON = this.VestingEditJSON;
      this.$refs.VestingInfoForm.calculateUnits(this.VestingJSON);
      window.$("#VestingCorrectionForm").modal("toggle");
    },
    // DeleteItemfromGrid: function(e) {
    //   e.preventDefault();
    //   //alert("Delete button clicked from BaseGrid..");
    //   const message = "Are you sure you want to delete this record?";
    //   this._ConfirmationPopup(message, "DELETE").then(result => {
    //     if (result.value) {
    //       let loader = this.$loading.show();
    //       let gview = window.$("#CorrectionGrid").data("kendoGrid");
    //       let dataItem = gview.dataItem(
    //         window.$(e.currentTarget).closest("tr")
    //       );
    //       let deleteData = { Id: dataItem.Id };
    //       let ItemsToBeDeleted = { list:BaseModelCorrection, payload:deleteData }
    //       this.DeleteItem(ItemsToBeDeleted).then(response => {
    //           $("#CorrectionGrid").data().kendoGrid.dataSource.read();
    //           this._AlertPopup("Deleted successfully!","success");
    //       }).finally(()=>{
    //         loader.hide();
    //       })
    //     }
    //   });
    // },
    // Correction Documnet Dropoff
    CorrectionAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#CorrectionGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedCorrection={...dataItem};

      this.selectedCorrection.TransactionID=dataItem.Id
      this.selectedCorrection.PartnerTitle=dataItem.ReceiverFullName
      this.selectedCorrection.PartnerId=dataItem.ReceiverId

      switch (this.selectedCorrection.BusinessEvent) {
        case "Issuance":
            this.selectedCorrection.CorrectionEventType="Issuance"
          break;
        case "Transfer":
            this.selectedCorrection.CorrectionEventType="Transfer"
          break;
        case "Vesting":
            this.selectedCorrection.CorrectionEventType="Vesting"
          break;  
        default:
          break;
      }

      this.selectedCorrection.BusinessEvent="Correction"
      this.filterCondition.batchQuery=true;

      let BatchGUIDArray=self.GetBatchGUIDArray(this.selectedCorrection.BatchGUID);

      this.filterCondition.filter = function(o){
          return o.BusinessEvent=='Correction' && (o.TransactionID == dataItem.Id || BatchGUIDArray.includes(o.BatchGUID))
      }

      this.$refs.correctionDocument.$refs.correctionDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    },
    AttachBatchDocuments(){

      let selectedItem = [];
      let selectedRowCount=0;

        //Get Next Batch Id
          const result = this.withFilter(BaseModelDocument.list,"");
          let batchId = (result.length <= 0) ? 1 : this._getIncrementalID(result,"BatchGUID");
          //Partner Program Concatenated List Change
          let programIdlist = new Set();
          let partnerIdList = new Set();

          let grid = $("#CorrectionGrid").data("kendoGrid");
              grid.select().each(function () {
              selectedRowCount++;
              let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
              let tempBatchId = [];
              if (!isNullOrUndefined(selectedDataItem.BatchGUID) && !selectedDataItem.BatchGUID=="") {
                  tempBatchId = selectedDataItem.BatchGUID.split(",");
              }
              tempBatchId.push(batchId);
              selectedDataItem.BatchGUID = tempBatchId.toString();

              selectedItem.push(selectedDataItem);
              programIdlist.add(selectedDataItem.ProgramId);
              partnerIdList.add(selectedDataItem.ReceiverId);
              (selectedDataItem.SenderId)?partnerIdList.add(selectedDataItem.SenderId):""
              });

          if (selectedRowCount<=1) {
              this._AlertPopup("Please Select Atleast 2 Rows","info");
          }else{
            const batchConfig = {
              Correction: {
               config: this._getBatchGUIDUpdateConfig("Correction"),
               updateData: selectedItem
              }
                };

                this.selectedCorrection={};
                this.selectedCorrection.ProgramId=null
                this.selectedCorrection.PartnerId=null
                this.selectedCorrection.ProgramIdList=[...programIdlist].toString();
                this.selectedCorrection.PartnerIdList=[...partnerIdList].toString();
                this.selectedCorrection.TransactionID=null
                this.selectedCorrection.BusinessEvent="Correction"
                this.selectedCorrection.Type="batch"
                this.selectedCorrection.BatchGUID=batchId;
                this.selectedCorrection.batchConfig=batchConfig
                this.selectedCorrection.parentGridId="CorrectionGrid"

                this.filterCondition.batchQuery=false;

                this.filterCondition.filter = `BusinessEvent eq 'Correction' and BatchGUID eq ${
                batchId
            }`;
            
            this.$refs.correctionDocument.$refs.correctionDocumentMgr.resetDropZoneGrid();

            window.$("#docModal").modal("toggle");
                
            }  
        },
    onBusinessEventChange(){
      //alert($("#ddlBusinessEvent").data("kendoDropDownList").text());
      this.selectedBusinessEvent=$("#ddlBusinessEvent").data("kendoDropDownList").text();
    }
  },
  mounted() {
    let self = this;
    //changes for Toolbar
    self._loadGridSettings(self.CorrectionGridId);

    //bind databound event to grid
    let grid = $("#CorrectionGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateCorrectionMasterData);
    grid.dataSource.fetch();
  },
};
</script>
<style>
  .RadAutoCompleteBoxPopup{
    float: right !important;
  }
</style>


